import React from 'react';

import { Button, Dialog, Text, VisuallyHidden } from '@betterment/samba-react';

type Props = {
  asOf: string;
  performanceDisclosure: string;
  onOpenChange?: (open: boolean) => void;
};

export const PerformanceDisclosure: React.FC<Props> = ({ asOf, performanceDisclosure, onOpenChange }) => {
  return (
    <Text variant="text50" color="text.weak" as="div">
      {asOf}{' '}
      <Dialog overlay="default" onOpenChange={onOpenChange}>
        <Dialog.Trigger data-samba-component={true} asChild={true}>
          <Button variant="textSecondary" aria-roledescription="disclosure">
            Disclosures
          </Button>
        </Dialog.Trigger>
        <VisuallyHidden>
          <Dialog.Title>Performance Disclosure</Dialog.Title>
        </VisuallyHidden>
        <Dialog.Content
          css={{
            padding: 'space.400',
            width: '100%',
            maxWidth: 'container.xlarge',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
          aria-label="Performance disclosure"
        >
          <Dialog.Description asChild={true}>
            <Text dangerouslySetInnerHTML={{ __html: performanceDisclosure }} />
          </Dialog.Description>
        </Dialog.Content>
      </Dialog>
    </Text>
  );
};
